import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useRazorpay from "react-razorpay";
import { useHistory } from "react-router-dom";

const useHandleRazorPayment = ({ packageAmount, songId, promotionData }) => {
    const dispatch = useDispatch();
    const [Razorpay, isLoaded] = useRazorpay();
    const userData = useSelector((state) => state.userData.userData);

    // ------------------Payment gateway razor pay------------

    const handlePayment = React.useCallback(async () => {
        const formData = new FormData();
        if (!promotionData?.id) {
            console.error("Missing promotionData.id, cannot proceed with payment");
            return;
        }
        formData.append("amount", packageAmount?.PackageAmount);
        formData.append("campaign_id", promotionData?.id);
        formData.append("song_name", songId?.songTitle);
        try {
            const response = await fetch(process.env.REACT_APP_MUZICNETWORK_URL, {
                method: "POST",
                headers: {
                    Authorization: `token ${process.env.REACT_APP_RAZOR_PAY_TOKEN}`, // Use the token from .env
                },
                body: formData,
            });

            const data = await response.json();

            if (!data?.razorpay_order_id) {
                throw new Error("Failed to create order");
            }

            const order = data?.razorpay_order_id;
            const callbackUrl = data?.callback_url;
            // Configure Razorpay options
            const options = {
                key: process.env.REACT_APP_RAZOR_PAY_KEY, // Test Key
                amount: packageAmount?.PackageAmount,
                currency: "INR",
                name: "GNTunes",
                description: "Paying for Campaign",
                order_id: order,
                callback_url: callbackUrl,
                redirect: true,
                allow_rotation: true,
                prefill: {
                    name: userData.name,
                    email: userData.email,
                    contact: userData.contactNumber,
                },
                notes: {
                    address: "Razorpay Corporate Office",
                },
                theme: {
                    color: "#C61414",
                },
                modal: {
                    ondismiss: function () {
                        console.log("Payment modal dismissed");
                    },
                },
            };

            const rzpay = new Razorpay(options); // Call Razorpay as a function
            rzpay.open();
        } catch (error) {
            console.error("Error processing payment:", error);
        }
    }, [Razorpay, isLoaded, packageAmount, userData, promotionData, dispatch]);
    return handlePayment;
}

export default useHandleRazorPayment;
